import React from 'react';
import {Box, Typography, Link} from '@mui/material';
import './Footer.scss';
import {FOOTER_LINKS} from '../../../shared/constants';
import {useTranslation, Trans} from 'react-i18next';
import ArrButton from '../../common/arr-button/ArrButton';
import {APP_VERSION} from '../../../config/env';

const Footer: React.FC = () => {
  const {t} = useTranslation();
  const version = APP_VERSION;
  const links = [
    {label: 'footer.privacyPolicyGdpr', href: FOOTER_LINKS.privacyPolicy},
    {label: 'footer.eula', href: FOOTER_LINKS.eula},
    {label: 'footer.cookiePolicy', href: FOOTER_LINKS.cookiePolicy},
    {
      label: 'footer.modernAntiSlaveryPolicy',
      href: FOOTER_LINKS.modernAntiSlaveryPolicy,
    },
  ];
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" className="arr-footer">
      <Box className="footer-top">
        <Typography
          variant="body2"
          className="typo-text body3_size"
          data-testid={`footer-consilio-llc-all-rights-reserved`}
        >
          {t('footer.consilioLlcAllRightsReserved', {currentYear})}
        </Typography>

        <Box className="footer-links">
          {links.map((link, index) => (
            <React.Fragment key={link.label}>
              <ArrButton
                href={link.href}
                variant="text"
                size="small"
                target="_blank"
                rel="noopener"
                dataTestId={`footer-button-${index}`}
              >
                {t(link.label)}
              </ArrButton>
              {index < links.length - 1 && (
                <span className="divider" data-testid={`footer-link-${index}`}>
                  |
                </span>
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
      <Box className="footer-bottom">
        <Typography
          className="typo-text body4_size"
          data-testid={`footer-privacy-policy-gdpr-compliance-end-user-license-agreement`}
        >
          <Trans i18nKey="footer.paragraph">
            <Link
              href={FOOTER_LINKS.privacyPolicy}
              color="inherit"
              target="_blank"
              rel="noopener"
              data-testid="privacy-policy-link"
            >
              Privacy Policy
            </Link>
            <Link
              href={FOOTER_LINKS.privacyPolicy}
              color="inherit"
              target="_blank"
              rel="noopener"
              data-testid="gdpr-compliance"
            >
              GDPR Compliance
            </Link>
            <Link
              href={FOOTER_LINKS.eula}
              color="inherit"
              target="_blank"
              rel="noopener"
              data-testid="eula-link"
            >
              End User License Agreement
            </Link>
          </Trans>
        </Typography>

        <Typography
          className="footer-version typo-text body4_size"
          data-testid={`footer-version`}
        >
          {t('footer.version', {version})}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
